<template>
	<v-card flat outlined>
		<v-card-title>
			Twoje konto
		</v-card-title>

		<v-card-text>
		<v-tabs
			v-model="tab"
			@change="setSession()"
			:hide-slider="true"
			:show-arrows="false"

		>
			<v-tab>
				{{ $vuetify.lang.t("$vuetify.views.settings.accountSettings") }}
			</v-tab>
			<v-tab>
				{{
					$vuetify.lang.t(
						"$vuetify.views.settings.notificationsTitle"
					)
				}}
			</v-tab>
			<v-tab>
				{{ $vuetify.lang.t("$vuetify.views.settings.activeSessions") }}
			</v-tab>
		</v-tabs>
		</v-card-text>
		<v-card-text>
			<v-tabs-items v-model="tab">
				<v-tab-item>
					<user-settings />
				</v-tab-item>

				<v-tab-item>
					<notification-settings />
				</v-tab-item>
			</v-tabs-items>
		</v-card-text>
	</v-card>
</template>

<script>
import UserSettings from "@/components/settings/UserSettings";
import NotificationSettings from "@/components/settings/NotificationSettings";
// import TrainingAndCertificatesSettings from "@/components/settings/TrainingAndCertificatesSettings";

export default {
	components: {
		UserSettings,
		NotificationSettings,
		// TrainingAndCertificatesSettings,
	},
	data() {
		return {
			tab: this.$route.params.typeOfSettings,
		};
	},
	watch: {
		tab() {
			switch (this.tab) {
				case 0:
					this.$router
						.push({ path: "/settings/user" })
						.catch(() => {});
					break;
				case 1:
					this.$router
						.push({ path: "/settings/notifications" })
						.catch(() => {});
					break;
				case 2: {
					window.location.href = this.url
					break;
				}

				default:
					this.$router
						.push({ path: "/settings/user" })
						.catch(() => {});
					break;
			}
		},
	},
	methods: {
		setSession() {
			// if (this.tab === 3) {
			// 	this.$store.commit('application/showLeave', this.url)
			// 	this.tab = 0;
			// }
		},
	},
	computed: {
		url() {
			return `${process.env.VUE_APP_LV_URL}/settings/sessions`;
		},
	},
};
</script>

<style>
.v-tab {
	text-transform: unset;
	border-bottom: 1px solid var(--v-grey-lighten4) !important;
	letter-spacing: normal;
	font-size: 14px;
	font-weight: 600;
}

.v-slide-group__content.v-tabs-bar__content {
	gap: 8px;
}
</style>
